export enum UserRoleName {
  Admin = 'ADMIN',
  Creator = 'CREATOR',
  Collaborator = 'COLLABORATOR',
}
